var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 29,
    height: 23,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXCAYAAAD3CERpAAAAAXNSR0IArs4c6QAAARRJREFUSEtjZICCILvfxYyMjDkMDP8VYGJI9C8GBoYzjAwMFWsOsh7GIk+SECNIdbDdr3wGRsYJxOj8z8BQte4gazsxanGpgVhq/+ceA8N/ReIN+r/8LSNr3IEDjH+I14NQCbX0938yNO9hZGQ4Soy+f/8Y/jMyMF5n+s28efVxxu+UWEqMfehqrvxlZLGlt6UMDAyM0wfAUoZbA2Hpq1FLyUmZxOoZWcH7nzHY/s8/YsOGCupej6ZeKoQiTiNGVuoFVeK/vzAwMHDTMkyRzL4NS71bGRgYvOhjKeMssKVBNj+UmJiZD/9nYJCiscWX2f+y2IMtBYEom/+CP1h++zMxMGJrDVLkFlhz5Rs388bt2xl/AgCZvXD+5E4oBQAAAABJRU5ErkJggg=="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-create-folder"
  }, /*#__PURE__*/React.createElement("use", {
    id: "icon-workspace-task-create-folder-image",
    href: "#img1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFolder);
export default __webpack_public_path__ + "static/media/create-folder.ec406df64c6ea09c852cea503fa96084.svg";
export { ForwardRef as ReactComponent };